import * as React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  EventConfigProps,
  EventConfigTypes,
  ComponentProps,
  WidgetProps,
} from '@intermix-dashboard/core';
import { useThemeObserver } from '../hooks/useThemeObserver';
export const IntermixBarChartComponent: React.FC<ComponentProps> = ({
  data,
  options,
  dataTransform,
  eventConfig,
}) => {
  const [eventData, setEventData] = React.useState<any>(null);
  const inputRef = React.useRef<any>(null);
  const [renderData, setRenderData] = React.useState<any>(null);
  const { display } = useThemeObserver();
  React.useEffect(() => {
    if (dataTransform) {
      setRenderData(dataTransform(data, options));
    } else {
      setRenderData(data);
    }
  }, [data, options.title, dataTransform]);

  React.useEffect(() => {
    if (eventData) {
      const event = new CustomEvent('intermix-event', {
        detail: eventData,
        bubbles: true,
        cancelable: false,
        composed: true, // makes the event jump shadow DOM boundary); */
      });
      inputRef.current.dispatchEvent(event);
      setEventData(null);
    }
  }, [eventData]);

  return (
    <div
      ref={inputRef}
      style={{ display: 'flex', width: '100%', flex: '1' }}
      id="intermix-card"
    >
      <>
        {renderData && display && (
          <Bar
            getDatasetAtEvent={(dataset) => {
              const datasetEvent = eventConfig?.find(
                (item: EventConfigProps) =>
                  item.type === EventConfigTypes.DATASET
              );
              if (
                datasetEvent &&
                dataset &&
                dataset.length > 0 &&
                typeof dataset[0]._index !== 'undefined'
              ) {
                setEventData({
                  key: datasetEvent.key,
                  value: dataset[0]._model.datasetLabel,
                });
              }
            }}
            onElementsClick={(elems) => {
              if (
                elems &&
                elems.length > 0 &&
                typeof elems[0]._index !== 'undefined'
              ) {
                const defaultEventConfig = eventConfig?.find(
                  (item: EventConfigProps) =>
                    item.type === EventConfigTypes.DEFAULT
                );
                if (defaultEventConfig) {
                  const event = new CustomEvent('intermix-event', {
                    detail: {
                      key: defaultEventConfig.key,
                      value: elems[0]._model.label,
                    },
                    bubbles: true,
                    cancelable: false,
                    composed: true, // makes the event jump shadow DOM boundary); */
                  });
                  inputRef.current.dispatchEvent(event);
                }
              }
            }}
            data={renderData}
            options={{
              responsive: true,
              title: {
                display: true,
                text: options.title ? options.title : '',
              },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
              },
            }}
          />
        )}
      </>
    </div>
  );
};

export const IntermixBarChartWidget: WidgetProps = {
  component: IntermixBarChartComponent,
  id: 'barchar-w1',
};
